<template>
  <div class="activity">
    <div class="tabbar-content">
      <keep-alive>
        <component v-bind:is="active"></component>
      </keep-alive>
    </div>
    <div class="tabbar">
      <div class="tabbar-item" @click="changeActive('Camp')">
        <img src="../../assets/images/activity/bar.svg"/>
        <span>营地</span>
        <span class="number">1</span>
      </div>
      <div class="tabbar-item" @click="changeActive('Ranking')">
        <img src="../../assets/images/activity/bar.svg"/>
        <span>榜单</span>
      </div>
      <!-- <div class="tabbar-item plus">
        <img src="../../assets/images/tabs/plus.svg"/>
      </div> -->
      <div class="tabbar-item" @click="changeActive('Task')">
        <img src="../../assets/images/activity/task.svg"/>
        <span>作业</span>
        <span class="number">5</span>
      </div>
    </div>
  </div>
</template>
<script>
import Camp from './Camp'
import Task from './Task'
import Ranking from './Ranking'
export default {
  components: {
    Camp,
    Task,
    Ranking
  },
  data () {
    return {
      active: 'Camp'
    }
  },
  methods: {
    changeActive (index) {
      this.active = index
    }
  }
}
</script>
<style lang="scss" scoped>
.activity {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .tabbar-content {
    height: calc(100% - 64px);
    overflow-y: scroll;
  }
  .tabbar {
    box-sizing: border-box;
    height: 64px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    .tabbar-item {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      position: relative;
      img {
        width: 28px;
        height: 28px;
      }
      span {
        height:14px;
        font-size:10px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:14px;
      }
      .number {
        position: absolute;
        top: -7px;
        right: -7px;
        width: 14px;
        height: 14px;
        border-radius:50%;
        background: #EB0A0A;
        font-size:10px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:14px;
        text-align: center;
      }
    }
    .plus {
      width: 40px;
      height: 40px;
      background:rgba(245,245,245,1);
      border-radius:8px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
